<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div>
    <p>
        <button
                (click)="switchType()"
                [ngClass]="{
                'import-as-new': isMarkedAsNew,
                'do-not-import': isMarkedAsDoNotImport,
                'update-origin': isMarkedAsUpdateOrigin,
                'potential-duplicate': isMarkedAsPotentialDuplicate
            }"
                class="badge"
        >
            {{ type | duplicateTypePipe }}
        </button>
    </p>
    <ng-container *ngIf="isNameEditorActive; then displayEditor; else displayName"></ng-container>
    <ng-template #displayName>
        <p
                (dblclick)="activateNameEditor()"
                [disabled]="!isNameChanged"
                [showDelay]="tooltipShowDelay"
                [tooltipText]="initialNameTooltipText"
                class="bg-gray clickable d-inline-flex"
                position="left"
                suiTooltip
        >
            <span [ngClass]="{ 'name-changed': isNameChanged }">
                <span>{{ name }}</span>
                <sui-svg-icon *ngIf="isMarkedAsPotentialDuplicate" icon="info" title="Potential duplicate" windeGrey/>
            </span>
        </p>
    </ng-template>
    <ng-template #displayEditor>
        <div>
            <div class="editor">
                <label>
                    <input #nameEditorInput [formControl]="nameEditorFormControl" type="text"/>
                </label>
            </div>
            <div [disabled]="!isNameChanged" [showDelay]="tooltipShowDelay" class="apply" position="right" suiTooltip tooltipText="Submit">
                <button (click)="applyNewName()" windeActionIcon>
                    <sui-svg-icon icon="check" windeGrey/>
                </button>
            </div>
        </div>
    </ng-template>
    <p>{{ longitude }}</p>
    <p>{{ latitude }}</p>
    <p class="bg-gray">{{ distance | number: '1.0-1' }}</p>
    <div *ngIf="layers?.length">
        <select
                (change)="layerIndexChanged()"
                [(ngModel)]="layerIndex"
                class="form-control form-control-sm borderless-selection"
                name="layerIndex"
        >
            <option *ngFor="let layer of layers" [ngValue]="layer.key">{{ layer.value }}</option>
        </select>
    </div>
    <p>{{ height | number: '1.0-1' }} {{ altitudeMode }}</p>
    <p>{{ blockedByPoleAngle }}</p>
    <div *ngIf="node.getType() === typeEnum.POTENTIAL_DUPLICATE && originsToSelect?.length" class="px-1">
        <span>Merge to:</span>
        <select
                (change)="changeNodeOrigin()"
                [(ngModel)]="origin"
                class="form-control form-control-sm w-auto borderless-selection ml-1"
                name="layerIndex"
        >
            <option *ngFor="let origin of originsToSelect" [ngValue]="origin">{{ origin.getName() }}</option>
        </select>
    </div>
</div>
